<template>
  <v-autocomplete
    color="primary"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    hide-no-data
    :disabled="disabled"
    v-model="bankSelected"
    :items="bankItems"
    :loading="bankLoading"
    :label="noLabel ? '' : label ? label : $t('SubAccount.Fields.bank')"
    :search-input.sync="bankSearch"
    item-text="bank_name"
    item-value="bank_code"
    item-disabled="disabled"
    return-object
  ></v-autocomplete>
</template>

<script>
import SubAccount from "@/api/sub_accounts";

export default {
  name: "SearcherBanks",

  props: {
    value: Array,
    noLabel: Boolean,
    label: String,
    disabled: Boolean,
  },

  computed: {
    bankItems() {
      return this.bank.map((c) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find((disabledItem) => disabledItem.id == c.id)
          : false;
        return Object.assign({}, c, { disabled });
      });
    },
  },

  data: () => ({
    bank: [],
    bankLoading: false,
    bankSearch: "",
    bankSelected: [],
  }),
  mounted() {
    this.bankLoading = true;
    SubAccount.fetchBankSelect()
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            var bank = response.data.banks;
            var Items = [];
            for (let key in bank) {
              Items.push(
                Object.assign(
                  {},
                  {},
                  {
                    bank_code: key,
                    bank_name: bank[key],
                  }
                )
              );
            }
            this.bank = Items;
          }
          this.bankLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.bankLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.bankSelected = this.value;
      },
    },
    bankSelected: {
      handler() {
        this.$emit("input", this.bankSelected);
      },
    },
  },
};
</script>